// extracted by mini-css-extract-plugin
var _1 = "AdminSSOUserCreationSettingCard-module__formFooter--x37st";
var _2 = "AdminSSOUserCreationSettingCard-module__provisionsField--CZDby";
export { _1 as "formFooter", _2 as "provisionsField" }
